var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.597,
    height: 19.965,
    viewBox: "0 0 20.597 19.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter_1_",
    "data-name": "twitter (1)",
    d: "M24.229,8.03,31.137,0H29.5l-6,6.973L18.711,0H13.185L20.43,10.544l-7.245,8.421h1.637L21.157,11.6l5.06,7.363h5.526L24.229,8.03Zm-2.242,2.606-.734-1.05L15.412,1.232h2.515L22.64,7.975l.734,1.05L29.5,17.789H26.987l-5-7.151Z",
    transform: "translate(-12.095 0.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.85208064565741f1d496ead15b4bc1d1.svg";
export { ForwardRef as ReactComponent };